import axios from 'axios';

export const UNKNOWN_ERROR_KEY = 'error.unknown';

const NETWORK_ERROR_KEY = 'error.network';
const SERVER_ERROR_KEY = 'error.server';

const ERROR_KEY_BY_STATUS: Record<number, string> = {
  401: 'error.unauthorized',
  403: 'error.forbidden',
  404: 'error.notFound',
};

export const resolveErrorKey = (
  error: unknown,
  fallbackKey = UNKNOWN_ERROR_KEY,
  statusOverrides: Record<number, string> = {},
): string => {
  if (!axios.isAxiosError(error)) {
    return fallbackKey;
  }

  if (!error.response) {
    return NETWORK_ERROR_KEY;
  }

  const { status } = error.response;
  const override = statusOverrides[status];

  if (override) {
    return override;
  }

  if (status >= 500) {
    return SERVER_ERROR_KEY;
  }

  return ERROR_KEY_BY_STATUS[status] ?? fallbackKey;
};
